export default "__VITE_ASSET__DcvQoEMS__"